import $ from 'jquery'
import { $elementExists } from './shared'
import { setInstallmentsCookies, getInstallmentsCookies } from './cookies'
import { selectors } from './selectors'

const SELECTOR = '.installment-selector'
const NO_COOKIE_CONTAINER_IDS = [selectors.sliders.installmentsOfferpage.replace('#', '')]

export const initInstallmentSelector = () => {
    const $container = $(SELECTOR)
    if (!$elementExists($container)) return

    const savedValue = getInstallmentsCookies()
    if (savedValue && !NO_COOKIE_CONTAINER_IDS.includes($container.attr('id'))) {
        const $savedInput = $container.find(`input[value="${savedValue}"]`)
        if ($savedInput.length) {
            $savedInput.prop('checked', true)
        }
    }

    const checkedVal = $container.find('input:checked').val()
    if (checkedVal) dispatchChange($container[0], checkedVal)

    $container.on('change', 'input[type="radio"]', function () {
        const value = $(this).val()
        dispatchChange($container[0], value)
        setInstallmentsCookies(value)
    })
}

function dispatchChange(element, value) {
    element.dispatchEvent(new CustomEvent('carouselChange', { detail: { value } }))
}
